import React from "react";

/**
 * React 노드 트리에서 순수 텍스트를 재귀 추출한다.
 *
 * 배경(spec 설계 결정 6): badge 렌더러가 인쇄 페이지 나눔을 `String(children)`으로 판정하는데,
 * children에 병원 버튼 같은 엘리먼트가 섞이면 `"[object Object]"`가 되어 판정이 깨진다.
 * 문자열 children일 때는 기존 `String(children)`과 **동일 결과**를 보장한다(계약).
 */
export function extractReactNodeText(node: React.ReactNode): string {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string") return node;
  if (typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(extractReactNodeText).join("");
  if (React.isValidElement(node)) {
    return extractReactNodeText((node.props as { children?: React.ReactNode })?.children);
  }
  return "";
}
